export enum ELiveStreamStatus {
  Created = 1,
  Starting = 2,
  Started = 3,
  Finished = 4,
  Published = 5,
}
